import classNames from 'classnames'

import styles from './Footnote.module.scss'

export const Footnote = (props) => (
  <div className={classNames(props.className, styles['footnote'])}>
    <div
      className={classNames(
        styles['footnote__text'],
        {
          [styles['footnote__text--not-align']]: props.textNotAlign,
        }
      )}
      dangerouslySetInnerHTML={{ __html: props.text}}
    />
    {props.more &&
      <div
        className={classNames(
          styles['footnote__btn-label'], {
            [styles[`footnote__btn-label-gap--${props.more.gap}`]]: props.more.gap
          }
        )}
      >
        <a
          className={ classNames(
            styles['footnote__btn'],
            {
              [styles['footnote__btn--theme-'+props.more.theme]]: props.more.theme,
              [styles['footnote__btn--pos-'+props.more.pos]]: props.more.pos,
            }
          ) }
          href={props.more.href}
          target="_blank"
          rel="noreferrer"
        >
          <span className={classNames(styles['footnote__btn-text'])}>{props.more.text}</span>
          <span
            className={classNames(
              styles['footnote__btn-icon'],
              styles['footnote__btn-icon--more']
            )}
          />
        </a>
      </div>
    }
  </div>
)
